import { Menu } from 'antd';
import { styled } from 'styled-components';
import { THEME } from '../../store/layout/layoutSlice';
import { COLORS } from '@src/constants/colors';

interface StyledBottomMenuProps {
  themeMode: THEME;
}
export const StyledDropdownMenu = styled.div<{ themeMode: THEME }>`
  padding: 4px 0;

  a {
    display: flex;
    flex-direction: row;
    align-items: left;
    text-decoration: none;
    color: inherit;
    padding: 8px 16px;
    &:hover {
      border-radius: 8px !important;
      background-color: ${(props) =>
        props.themeMode === THEME.DARK ? '#ffffff' : '#dddddd'} !important;
      color: ${(props) =>
        props.themeMode === THEME.DARK ? '#000000' : '#000000'} !important;
    }
  }
`;

export const StyledBottomMenu = styled(Menu)<StyledBottomMenuProps>`
  &.ant-menu {
    cursor: pointer;
    background-color: inherit;
    border-inline-end: none !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    transition: background-color 0.3s;
    height: 50px !important;
    line-height: 50px !important;
    padding: 10px 16px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) =>
      props.themeMode === THEME.DARK
        ? COLORS.text.dark
        : COLORS.text.light} !important;
  }

  .ant-menu-item:hover,
  .ant-menu-submenu-title:hover {
    background-color: ${(props) =>
      props.themeMode === THEME.DARK ? '#ffffff' : '#191c1e'} !important;
    color: ${(props) =>
      props.themeMode === THEME.DARK ? '#000000' : '#ffffff'} !important;
  }

  .ant-menu-item-selected,
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    font-weight: bold !important;
    background-color: ${(props) =>
      props.themeMode === THEME.DARK ? '#ffffff' : '#191c1e'} !important;
    color: ${(props) =>
      props.themeMode === THEME.DARK ? '#000000' : '#ffffff'} !important;
  }

  .ant-menu-item-selected::before,
  .ant-menu-submenu-selected .ant-menu-item-selected::before {
    content: '';
    width: 6px;
    border-radius: 20px !important;
    height: 32px;
    position: absolute;
    left: 0px;
    z-index: 10;
  }

  .ant-menu-item-divider {
    margin: 16px 0 !important;
    border-color: rgba(117, 122, 141, 0.3) !important;
  }

  @media (max-width: 768px) {
    .ant-menu-item {
      display: flex;
      justify-content: center;
    }
  }
`;
